import { useQuery } from '@tanstack/react-query';

import { RequestConfig } from '~/common/services/requests';
import { Role } from '../../../../../types';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../../logic/unwrapNonPaginatedResponseDataAs';
import { NonPaginatedResponse } from '../../../../types/NonPaginatedResponse';
import { USER_BASE_PATH } from '../../constants/userBasePath';
import { getUserRoles } from '../../requests/getUserRoles';

export const useUserRoles = (
  params?: RequestConfig['params'],
  options?: { enabled?: boolean },
) => {
  const { constructGet } = useRequestConstructor();

  const { data, refetch, ...rest } = useQuery<
    NonPaginatedResponse<Role[]> | undefined
  >({
    queryKey: [USER_BASE_PATH, 'roles', params],
    queryFn: () => getUserRoles(constructGet, params),
    ...options,
  });

  return {
    ...unwrapNonPaginatedResponseDataAs(data, refetch, 'userRoles'),
    ...rest,
  };
};
